import { memo } from 'react'
import styled from 'styled-components'
import { Spinner } from '@pancakeswap/uikit'

const Cover = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgb(14 14 44 / 20%);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;

  svg {
    width: 40px;
  }
`

function App() {
  return (
    <Cover>
      <Spinner />
    </Cover>
  )
}

export default memo(App)
